angular = require('angular')

class DeviceFactory
  @$injector: ['RestfulResource', '$http', '$cookies', 'config', 'Upload', 'Tag']
  constructor: (RestfulResource, $http, $cookies, config, Upload, Tag)->    
    TagServ = new Tag();
    url = "#{config.api.url}/devices/"    
    actions = 
      secret:
        method: "PUT"
        url: "#{url}:_id/secret"
    Device = new RestfulResource("#{url}/:_id", {_id: "@_id"}, actions)      
    Device.prototype.$screenshot = ()->
      $http.get "#{url}#{@_id}/snapshot"
        .then (res)->
          return res.data
    Device.prototype.$details = ()->
      $http.get "#{url}#{@_id}/details"
        .then (res)->
          return res.data
    Device.prototype.$reboot = ()->
      $http.put "#{url}#{@_id}/reboot"
        .then (res)->
          return res.data
    Device.prototype.$timezone =(timezone)->
      $http
        method: "PUT"
        url: "#{url}#{@_id}/timezone"
        data:
          timezone: timezone
      .then (res)->
        return res.data
    Device.prototype.$firewall = (testJsonFile)->
      $http
        method: "PUT"
        url: "#{url}#{@_id}/firewall-test"
      .then (res)->
        return res.data
      .catch (err)->
        return "Error: please refresh token and retry, or contact to the administrator."

    Device.prototype.$usage = ()->
      $http.get "#{url}#{@_id}/usage", ignoreLoadingBar: true
        .then (res)->
          return res.data

    Device.prototype.$support = ()->
      $http.get "#{url}#{@_id}/support", ignoreLoadingBar: true
        .then (res)->
          return res.data

    Device.prototype.$install = (app)->
      $http.post "#{url}#{@_id}/apps", app

    Device.prototype.$ota = (ota)->
      $http.post "#{url}#{@_id}/ota", ota

    Device.prototype.$logcat = ()->
      window.open "#{url}#{@_id}/logcat?access_token=#{$cookies.get('token')}", "_blank"

    Device.prototype.$pull = (path)->
      window.open "#{url}#{@_id}/resources/#{path}?access_token=#{$cookies.get('token')}", "_blank"
    Device.statistic = ()->
      $http.get "#{url}statistic"
        .then (res)=>
          return res.data
    Device.prototype.$push = (resource, path) ->        
      $http
        method: "POST"
        url: "#{url}#{@_id}/#{path}"
        data: resource
      .then (result)->
          return result.data

    Device.prototype.$restart = (pkg) ->
      $http
        method: "PUT"
        url: "#{url}#{@_id}/apps/#{pkg}/restart"
      .then (result)->
          return result.data

    Device.prototype.$uninstall = (pkg) ->
        $http
          method: "DELETE"
          url: "#{url}#{@_id}/apps/#{pkg}"
        .then (result)->
            return result.data

    Device.prototype.$move = (pkg) ->
      $http
        method: "PUT"
        url: "#{url}#{@_id}/apps/#{pkg}/move"
      .then (result)->
          return result.data


    Device.prototype.$tag = (tag) ->
      $http
        method: "POST"
        url: "#{url}#{@_id}/tags"
        data: tag
      .then (result)=>
        @tags ?= []
        exists = false
        angular.forEach @tags, (val)->
          if val._id is tag._id
            exists = true
        if not exists              
          @tags.push(tag)
        return result.data

    Device.prototype.$untag = (tag) ->        
      $http
        method: "DELETE"
        url: "#{url}#{@_id}/tags/#{tag._id}"
      .then (result)=>
        idx = @tags.indexOf(tag)
        @tags.splice(idx, 1)
        return result.data    

    Device.prototype.$assign = (company)->        
      $http
        method: "POST"
        url: "api/companies/#{company._id}/devices/"
        data: @
      .then (result)->
        return result.data      
    Device.prototype.$readPref = (pkg) ->
        $http
          method: "GET"
          url: "#{url}#{@_id}/apps/#{pkg}/pref"
        .then (result)->
            return result.data
    Device.prototype.$savePref = (pkg, content) ->
      $http
        url: "#{url}#{@_id}/apps/#{pkg}/pref"
        method: 'PUT'
        data:
          content: content
      .then (result)->
        return result.data
    Device.locations = (criteria)=>
      $http
        method: "GET"
        url: "#{url}/locations"
        params: criteria
      .then (result)=>
        return result.data

    Device.prototype.bulkCsvUpdate = (csvFile)=>
      new Promise (res, rej)->
        if csvFile  
          Upload.upload 
            url: "#{url}bulk-csv-update"
            file: csvFile
          .then (result)->
            res result.data

    Device.prototype.download = (path)=>
      new Promise (res, rej)->
        $http
          method: "GET"
          url: "#{url}download/#{path}"
        .then (result)->
          res result

    return Device
module.exports = DeviceFactory




// WEBPACK FOOTER //
// ./src/component/device/device.coffee